// extracted by mini-css-extract-plugin
module.exports = {"RecaptchaInfoVerificationRequired":"ShowPhoneButton_RecaptchaInfoVerificationRequired__2_jwV"};